import * as actionTypes from './actionTypes';
import * as actions from './index';

export const getUploadProjectsStart = () => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_PROJECTS_START
    };
};

export const getUploadProjectsSuccess = (projects) => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_PROJECTS_SUCCESS,
        projects: projects
    };
};

export const getUploadProjectsFail = (error) => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_PROJECTS_FAIL,
        error: error
    };
};

export const getDeletedUploadProjectsStart = () => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_DELETED_PROJECTS_START
    }
}

export const getDeletedUploadProjectsSuccess = (projects) => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_DELETED_PROJECTS_SUCCESS,
        deletedProjects: projects
    }
};

export const getDeletedUploadProjectsFail = (error) => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_DELETED_PROJECTS_FAIL,
        error: error
    };
};

export const getDeletedUploadProjects = () => {
    return dispatch => {
        window.flow.getProjectsByFields([{ field: "projecttype", type: '=', value: 'project_delete', 'order': 'name' }])
            .then(res => {
                dispatch(getDeletedUploadProjectsSuccess(res.project.elements));
            }).catch(res => {
                dispatch(getDeletedUploadProjectsFail(res.message));
                dispatch(actions.applicationError(res.message));
            });
    };
}

export const getUploadProjects = () => {
    return dispatch => {
        dispatch(getUploadProjectsStart());
        window.flow.pmdbulprojectsGetAll().then(res => {
            dispatch(getUploadProjectsSuccess(res.objects.elements));
        }).catch(res => {
            dispatch(getUploadProjectsFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const newUploadProjectStart = () => {
    return {
        type: actionTypes.UPLOADPROJECTS_NEW_PROJECT_START
    }
}

export const newUploadProjectSuccess = (project) => {
    return {
        type: actionTypes.UPLOADPROJECTS_NEW_PROJECT_SUCCESS,
        payload: { project: project }
    }
}

export const newUploadProjectFail = (error) => {
    return {
        type: actionTypes.UPLOADPROJECTS_NEW_PROJECT_FAIL,
        error: error
    }
}

export const getUploadProjectSchemesSuccess = (schemes) => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_SCHEMES_SUCCESS,
        payload: schemes
    }
}

export const getUploadProjectSchemesFail = (err) => {
    return {
        type: actionTypes.UPLOADPROJECTS_GET_SCHEMES_FAIL,
        payload: err
    }
}

export const setActiveUploadProject = (id) => {
    return ({
        type: actionTypes.UPLOADPROJECTS_SET_ACTIVE_PROJECT,
        payload: { activeProject: id }
    });
}

const addClipsToUploadProjectSuccess = (projectId, clipIds) => {
    return {
        type: actionTypes.UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_SUCCESS,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const addClipsToUploadProjectStart = (projectId, clipIds) => {
    return {
        type: actionTypes.UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_START,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const addClipsToUploadProjectFail = (projectId, clipIds) => {
    return {
        type: actionTypes.UPLOADPROJECTS_ADD_CLIPS_TO_PROJECT_FAIL,
        error: 'Could not add clips',
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

export const addClipsToUploadProject = (projectId, clipIds, type) => {
    return ((dispatch, getState) => {
        dispatch(addClipsToUploadProjectStart(projectId, clipIds));
        window.flow.projectAddClip(projectId, clipIds, 'addtop').then(res => {
            dispatch(addClipsToUploadProjectSuccess(projectId, clipIds));
        }).catch(res => {
            console.log(res);
            dispatch(addClipsToUploadProjectFail(projectId, clipIds));
            dispatch(actions.addMessage('popup.title.project.add.fail', null, 'text', 'dialog'));
        });
    });
}

const removeClipsFromUploadProjectSuccess = (projectId, clipIds) => {
    return {
        type: actionTypes.UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_SUCCESS,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const removeClipsFromUploadProjectStart = (projectId, clipIds) => {
    return {
        type: actionTypes.UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_START,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const removeClipsFromUploadProjectFail = (projectId, clipIds) => {
    return {
        type: actionTypes.UPLOADPROJECTS_REMOVE_CLIPS_FROM_PROJECT_FAIL,
        error: 'Could not remove clips',
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

export const removeClipsFromUploadProject = (projectId, clipIds) => {
    return ((dispatch, getState) => {
        dispatch(removeClipsFromUploadProjectStart(projectId, clipIds));
        window.flow.projectRemoveClipById(projectId, clipIds).then(res => {
            dispatch(removeClipsFromUploadProjectSuccess(projectId, clipIds));
            dispatch(actions.getUploadProjectTree());
            // dispatch(actions.getUploadProjects());
            dispatch(actions.addMessage('popup.title.project.remove.success', null, 'text', 'dialog'));
        }).catch(res => {
            console.log(res);
            dispatch(removeClipsFromUploadProjectFail(projectId, clipIds));
            dispatch(actions.addMessage('popup.title.project.remove.fail', null, 'text', 'dialog'));
        });
    });
}

export const deleteUploadProject = (projectId) => {
    return (dispatch => {
        dispatch({ type: actionTypes.UPLOADPROJECTS_DELETE_PROJECT_START });
        window.flow.delProject(projectId).then(res => {
            dispatch(actions.addMessage('popup.title.project.delete.success', null, 'text', 'dialog'));
            dispatch({ type: actionTypes.UPLOADPROJECTS_DELETE_PROJECT_SUCCESS, payload: { projectId: projectId } });
        }).catch(res => {
            dispatch(actions.addMessage('popup.title.project.delete.fail', null, 'text', 'dialog'));
            dispatch({ type: actionTypes.UPLOADPROJECTS_DELETE_PROJECT_FAIL });
        });
    });
}

export const removeUploadProjectLinks = (projectId) => {
    return (dispatch => {
        dispatch({ type: actionTypes.UPLOADPROJECTS_PROJECT_REMOVE_LINKS_START });
        window.flow.projectRemoveLinks(projectId).then(res => {
            dispatch({ type: actionTypes.UPLOADPROJECTS_PROJECT_REMOVE_LINKS_SUCCESS });
            setTimeout(() => dispatch(actions.getUploadProjectTree()), 1000);
        }).catch(res => {
            dispatch({ type: actionTypes.UPLOADPROJECTS_PROJECT_REMOVE_LINKS_FAIL });
        });
    });
}

//UPLOADPROJECT SCHEMES
export function saveNewUploadProject(obj) {
    return (dispatch => {
        dispatch(newUploadProjectStart());
        window.flow.pmdbulprojectsNewTree(obj.type, obj.title).then(res => {
            dispatch(newUploadProjectSuccess(res));
            setTimeout(() => dispatch(actions.getUploadProjectTree()), 2000);
        }).catch(err => {
            dispatch(newUploadProjectFail(err.message));
            dispatch(actions.applicationError(err.message));
        })
    })
}

export function getUploadProjectSchemes() {
    return (dispatch => {
        window.flow.pmdbulprojectsgetprojectschemes()
            .then(res => {
                dispatch(actions.getUploadProjectSchemesSuccess(res));
            })
            .catch(err => {
                dispatch(actions.getUploadProjectSchemesFail(err));
            })
    })
}

export const getGrantingGroup = () => {
    return (dispatch => {
        window.flow.grantingGetGroup(1).then(res => {
            console.log("LAMTEST getGrantingGroup res", res);
        }).catch(err => {
            console.log("LAMTEST getGrantingGroup err", err);
        })
    })
}

export const setCurrentUploadProject = (data) => {
    return {
        type: actionTypes.UPLOADPROJECTS_SET_CURRENT_UPLOADPROJECT,
        payload: data
    }
}

export const updateUploadProjectMetadata = ({ id, metadata }) => {
    return dispatch => {
        dispatch({ type: actionTypes.UPLOADPROJECTS_SET_LOADING, payload: { loading: true } });
        window.flow.editProject(id, metadata).then((project) => {
            dispatch({ type: actionTypes.UPLOADPROJECTS_SET_LOADING, payload: { loading: false } });
            dispatch(actions.getUploadProjectTree());
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.UPLOADPROJECTS_SET_LOADING, payload: { loading: false } });
        });
    }
}

export const addMemberToUploadProject = (id, member) => {
    return ((dispatch) => {
        dispatch({ type: actionTypes.ADD_MEMBER_PROJECT_START });
        dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectAddMember(id, member).then((project) => {
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            dispatch(actions.getUploadProjectTree());
        }).catch((res) => {
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        });
    });
}

export const delMemberFromUploadProject = (projectId, memberId) => {
    console.log("LAMTEST delMemberFromUploadProject projectId memberId", projectId);
    return ((dispatch) => {
        dispatch({ type: actionTypes.DELETE_MEMBER_PROJECT_START });
        dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectDelMember(projectId, memberId).then(project => {
            console.log("LAMEST delMemberFromUploadProject project", project);
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            dispatch(actions.getUploadProjectTree());
        }).catch(res => {
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        })
    })
}
